import getOrganizationFailedTnx from "../../ajax/actions/failed-site-transactions/organizationFailed-get";
import store from "../../Store";

export function toggleOrganizationFailedSiteFilter(e) {
  return function (dispatch, getState) {
    let { name, value } = e.target;

    dispatch({
      type: "TOGGLE-FAILED-ORGANIZATION-FILTER",
      name,
      value,
    });

    const { data } = getState().organizationFailedTnxList;

    store.dispatch(getOrganizationFailedTnx(data.organization_id, true));
  };
}

export function setOrganizationFailedID(id) {
  return function (dispatch) {
    dispatch({ type: "SET-ORGANIZATION-FAILED-ID", id });
  };
}

export function toggleFailedOrganizationModal() {
  return function (dispatch) {
    dispatch({ type: "TOGGLE-FAILED-ORGANIZATION-MODAL" });
  };
}

export function toggleFailedOrganizationStatusModal() {
  return function (dispatch) {
    dispatch({ type: "TOGGLE-FAILED-ORGANIZATION-STATUS-MODAL" });
  };
}

export function resetSearchParams() {
  return function (dispatch) {
    dispatch({ type: "RESET-SEARCH-PARAMS" });
  };
}
